// extracted by mini-css-extract-plugin
export default {"container":"MenuButton_container__X7bjb","circle":"MenuButton_circle__uvqv2"};